import { Image } from '@unistocks/components/basic/image';
import { NativePressable } from '@unistocks/components/basic/pressable';
import { Card } from '@unistocks/components/layout/card';
import { Column } from '@unistocks/components/layout/flex';
import {
  EventViewLayout,
  eventViewLayoutOptions
} from '@unistocks/features/dashboard/components/dashboard-data/event-view/layout';
import { ValueListItem } from '@unistocks/features/dashboard/components/value-list-item/value-list-item';
import { FLAGS } from '@unistocks/features/portfolios/flags';
import { formatCurrency, formatPercentage } from '@unistocks/shared/localization/index.ts';
import { SelectProps } from '@unistocks/types/select-props';
import { View, YGroup } from 'tamagui';

export const EventViewLayoutSelect: React.FC<SelectProps<EventViewLayout>> = ({
  value,
  onChange
}) => (
  <Column gap={'$3'} mb={'$3'}>
    {/* TODO: Something is interfering with the press events when moving to this tab. NativePressable works for now */}
    {eventViewLayoutOptions.map(option => (
      <NativePressable key={option.value} onPress={() => onChange(option.value)}>
        <Card
          bordered
          elevate
          bg={value === option.value ? '$color4' : 'transparent'}
          $platform-web={{ cursor: 'pointer' }}
        >
          {option.value === EventViewLayout.List ? (
            <List />
          ) : option.value === EventViewLayout.Carousel ? (
            <Carousel />
          ) : null}
        </Card>
      </NativePressable>
    ))}
  </Column>
);

const List = () => {
  return (
    <YGroup padding={'$true'}>
      <YGroup.Item>
        <ValueListItem bg={'transparent'}>
          <Image rounded source={FLAGS.us_market} />
          <ValueListItem.Label flex={1}>Example Asset</ValueListItem.Label>
          <ValueListItem.Value status={'positive'} width={'auto'} flexGrow={0} ml={'auto'}>
            {formatPercentage(0.0151)}
          </ValueListItem.Value>
        </ValueListItem>
      </YGroup.Item>
      <YGroup.Item>
        <ValueListItem bg={'transparent'}>
          <Image rounded source={FLAGS.us_market} />
          <ValueListItem.Label flex={1}>Example Asset</ValueListItem.Label>
          <ValueListItem.Value status={'negative'} width={'auto'} flexGrow={0} ml={'auto'}>
            {formatPercentage(-0.0055)}
          </ValueListItem.Value>
        </ValueListItem>
      </YGroup.Item>
    </YGroup>
  );
};

const Carousel = () => {
  return (
    <YGroup padding={'$true'}>
      <YGroup.Item>
        <ValueListItem
          unstyled
          alignItems="center"
          justifyContent="space-between"
          bg={'transparent'}
        >
          <View flex={1}>
            <Image rounded w={'$4'} h={'$4'} source={FLAGS.us_market} />
          </View>
          <Column alignItems="center" flex={8}>
            <ValueListItem.Label size={'$7'}>Example Asset</ValueListItem.Label>
            <ValueListItem.Value size={'$8'} mr={'$4'} status={'positive'} textAlign="center">
              {formatCurrency(1000, 'USD')}
            </ValueListItem.Value>
          </Column>
          <View flex={1} />
        </ValueListItem>
      </YGroup.Item>
    </YGroup>
  );
};
